export default {
    defaultWidth: 640,
    defaultHeight: 360,
    barHeight: 60,
    logoRadius: 150,
    logoX: 500,
    logoY: 30
}


